import { createFileRoute } from '@tanstack/react-router'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { Layout } from '@/components/custom/layout'
import { Script } from '@/components/settings-route/switchboard/ivr-script'
import { Record } from '@/components/settings-route/switchboard/ivr-record'

export const Route = createFileRoute('/_auth/switchboard/ivr')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Layout.Body>
      <Tabs defaultValue="script">
        <TabsList className="mb-2">
          <TabsTrigger value="script">Kịch bản</TabsTrigger>
          <TabsTrigger value="record">File ghi âm</TabsTrigger>
        </TabsList>
        <TabsContent value="script">
          <Script />
        </TabsContent>
        <TabsContent value="record">
          <Record />
        </TabsContent>
      </Tabs>
    </Layout.Body>
  )
}
